var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommentpostsuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_26777",
    "data-name": "Group 26777",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 103.053,
    height: 100.669,
    viewBox: "0 0 103.053 100.669",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12010",
    "data-name": "Rectangle 12010",
    width: 103.053,
    height: 100.669,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26776",
    "data-name": "Group 26776",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23444",
    "data-name": "Path 23444",
    d: "M0,110.043c.18-.19.35-.529.542-.542a2.62,2.62,0,0,1,1.52.159.952.952,0,0,1,.059,1.556,2.671,2.671,0,0,1-1.505.276c-.2,0-.41-.286-.615-.442v-1.006",
    transform: "translate(0 -19.632)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23445",
    "data-name": "Path 23445",
    d: "M67.749,92.574H83.242q5.536,0,11.07,0c1,0,1.511.423,1.523,1.2s-.5,1.211-1.484,1.237c-.235.007-.469,0-.7,0H13.441c-.369,0-.817.121-1.088-.044A2.334,2.334,0,0,1,11.3,93.869c-.19-.666.3-1.129.977-1.272a4.407,4.407,0,0,1,.9-.023H39.336c-10.076-4.3-17.543-11.281-21.861-21.392a38,38,0,0,1-.107-30.607,39.245,39.245,0,0,1,74.589,7.071c4.015,18.715-6.5,38.3-24.209,44.928M53.592,18.952A36.809,36.809,0,1,0,90.355,55.919,36.889,36.889,0,0,0,53.592,18.952",
    transform: "translate(-2.018 -2.961)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23446",
    "data-name": "Path 23446",
    d: "M6.6,111.628c-.3,0-.6.014-.9,0a1.131,1.131,0,0,1-1.189-1.212,1.154,1.154,0,0,1,1.207-1.207c.565-.034,1.133-.015,1.7-.009a1.176,1.176,0,0,1,1.332,1.184c.022.848-.513,1.252-1.35,1.254H6.6v-.007",
    transform: "translate(-0.809 -19.582)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23447",
    "data-name": "Path 23447",
    d: "M117.947,111.635c-1.526.006-2.1-.342-2.078-1.243.025-.844.624-1.195,2.042-1.195.3,0,.6-.006.9,0a1.183,1.183,0,0,1,1.314,1.208,1.149,1.149,0,0,1-1.278,1.227c-.3.007-.6,0-.9,0",
    transform: "translate(-20.78 -19.583)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23448",
    "data-name": "Path 23448",
    d: "M125.045,110.486c-.132.707-.51,1.171-1.277,1.134a1.2,1.2,0,0,1,.1-2.393c.744.026,1.115.517,1.179,1.259",
    transform: "translate(-21.992 -19.589)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23449",
    "data-name": "Path 23449",
    d: "M57.319,118.875v-1.188c-.381-.018-.737-.049-1.093-.05-2.647,0-5.294,0-7.941-.006-.333,0-.759.076-.977-.094-.38-.3-.871-.758-.868-1.148s.5-.857.886-1.131c.257-.181.712-.1,1.078-.1q11.459-.006,22.919,0c.366,0,.824-.075,1.078.108.386.279.871.756.867,1.144s-.5.844-.886,1.134c-.222.168-.646.089-.979.09q-3.921.007-7.841,0H62.4v1.238c1.651,0,3.25,0,4.848,0,1.236,0,1.825.41,1.8,1.236-.025.781-.631,1.206-1.758,1.206q-7.137,0-14.274,0c-.168,0-.336.007-.5-.009a1.182,1.182,0,0,1-1.224-1.21,1.14,1.14,0,0,1,1.287-1.221c1.539,0,3.077,0,4.742,0",
    transform: "translate(-8.329 -20.649)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23450",
    "data-name": "Path 23450",
    d: "M84.409,117.634c-.769,0-1.538.012-2.306,0s-1.327-.388-1.354-1.18c-.03-.853.54-1.27,1.351-1.284q2.306-.039,4.613,0c.813.012,1.38.432,1.353,1.282-.024.79-.578,1.168-1.35,1.183s-1.538,0-2.307,0",
    transform: "translate(-14.482 -20.651)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23451",
    "data-name": "Path 23451",
    d: "M39.583,117.63c-.8,0-1.605.025-2.406-.007a1.179,1.179,0,0,1-1.278-1.252,1.155,1.155,0,0,1,1.233-1.194c1.637-.033,3.276-.038,4.912.011a1.135,1.135,0,0,1,1.179,1.238,1.169,1.169,0,0,1-1.235,1.193c-.8.039-1.6.009-2.406.01",
    transform: "translate(-6.438 -20.652)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23452",
    "data-name": "Path 23452",
    d: "M46.41,68.545c1.663-1.593,3.247-3.039,4.752-4.565Q61.291,53.7,71.387,43.387a6.9,6.9,0,0,1,11.83,3.654,7.157,7.157,0,0,1-2.194,6.585q-6,6.092-11.976,12.2Q59.89,75.161,50.734,84.493c-2.7,2.756-5.5,2.774-8.192.038q-6.7-6.81-13.388-13.634c-3.644-3.74-2.67-9.662,1.892-11.705A6.9,6.9,0,0,1,38.9,60.775c2.316,2.33,4.607,4.684,6.9,7.035.253.259.464.561.606.735M29.374,65.278a5.171,5.171,0,0,0,1.6,3.988q6.6,6.7,13.187,13.414c1.914,1.946,3.014,1.932,4.953-.044Q60,71.545,70.88,60.451c2.865-2.92,5.739-5.831,8.589-8.765a4.584,4.584,0,0,0,1.2-4.816,4.292,4.292,0,0,0-3.377-3.108,4.505,4.505,0,0,0-4.342,1.512Q60.459,58.03,47.943,70.764c-1.106,1.128-1.549,1.128-2.646.016-2.753-2.794-5.488-5.608-8.262-8.382a4.224,4.224,0,0,0-4.9-.992,4.32,4.32,0,0,0-2.758,3.874",
    transform: "translate(-4.83 -7.389)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23453",
    "data-name": "Path 23453",
    d: "M115.526,43.894a1.2,1.2,0,1,1-1.187-1.184,1.2,1.2,0,0,1,1.187,1.184m-1.192-.5a.513.513,0,0,0-.514.517.5.5,0,0,0,.488.511.514.514,0,1,0,.025-1.028",
    transform: "translate(-20.289 -7.66)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23454",
    "data-name": "Path 23454",
    d: "M23.934,25.145a1.2,1.2,0,1,1-1.187-1.184,1.2,1.2,0,0,1,1.187,1.184m-1.192-.5a.513.513,0,0,0-.514.517.5.5,0,0,0,.488.511.514.514,0,1,0,.025-1.028",
    transform: "translate(-3.863 -4.297)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23455",
    "data-name": "Path 23455",
    d: "M98.291,19.209A1.2,1.2,0,1,1,97.1,18.024a1.2,1.2,0,0,1,1.187,1.185m-1.192-.5a.513.513,0,0,0-.514.517.5.5,0,0,0,.488.511.514.514,0,1,0,.025-1.028",
    transform: "translate(-17.198 -3.233)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23456",
    "data-name": "Path 23456",
    d: "M45.014,2.015a1.816,1.816,0,1,1-1.8-1.8,1.823,1.823,0,0,1,1.8,1.8M43.207,1.26a.779.779,0,0,0-.78.785.765.765,0,0,0,.741.775.789.789,0,0,0,.81-.759.8.8,0,0,0-.771-.8",
    transform: "translate(-7.422 -0.039)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23457",
    "data-name": "Path 23457",
    d: "M119.661,1.7a1.72,1.72,0,1,1-1.7-1.7,1.726,1.726,0,0,1,1.7,1.7M117.95.986a.737.737,0,0,0-.738.743.724.724,0,0,0,.7.734.747.747,0,0,0,.767-.718.755.755,0,0,0-.73-.758",
    transform: "translate(-20.844 0)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23458",
    "data-name": "Path 23458",
    d: "M9.141,50.41H5.606a.205.205,0,1,1,0-.41H9.141a.205.205,0,1,1,0,.41",
    transform: "translate(-0.969 -8.967)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23459",
    "data-name": "Path 23459",
    d: "M8.507,51.572a.2.2,0,0,1-.172-.094L6.425,48.5a.2.2,0,0,1,.345-.222l1.91,2.974a.2.2,0,0,1-.062.283.2.2,0,0,1-.111.033",
    transform: "translate(-1.146 -8.642)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23460",
    "data-name": "Path 23460",
    d: "M6.6,51.572a.2.2,0,0,1-.111-.033.2.2,0,0,1-.062-.283l1.91-2.974a.2.2,0,0,1,.345.222L6.77,51.478a.2.2,0,0,1-.172.094",
    transform: "translate(-1.146 -8.642)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23461",
    "data-name": "Path 23461",
    d: "M5.8,1.689H4.792L5.338.84A.148.148,0,1,0,5.088.68l-.568.883L3.954.68A.149.149,0,0,0,3.7.84l.546.849H3.24a.149.149,0,1,0,0,.3H4.249L3.7,2.836a.149.149,0,0,0,.045.205.144.144,0,0,0,.08.024A.147.147,0,0,0,3.954,3l.567-.883L5.088,3a.145.145,0,0,0,.125.069.139.139,0,0,0,.08-.024.147.147,0,0,0,.045-.205l-.545-.849H5.8a.149.149,0,0,0,0-.3",
    transform: "translate(-0.554 -0.11)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23462",
    "data-name": "Path 23462",
    d: "M77.089,12.03H74.012a.178.178,0,1,1,0-.357h3.077a.178.178,0,1,1,0,.357",
    transform: "translate(-13.242 -2.093)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23463",
    "data-name": "Path 23463",
    d: "M76.538,13.042a.179.179,0,0,1-.15-.082l-1.663-2.59a.178.178,0,1,1,.3-.193l1.663,2.59a.177.177,0,0,1-.054.246.169.169,0,0,1-.1.029",
    transform: "translate(-13.396 -1.81)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23464",
    "data-name": "Path 23464",
    d: "M74.874,13.042a.169.169,0,0,1-.1-.029.177.177,0,0,1-.054-.246l1.663-2.59a.178.178,0,1,1,.3.193l-1.663,2.59a.179.179,0,0,1-.15.082",
    transform: "translate(-13.396 -1.81)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23465",
    "data-name": "Path 23465",
    d: "M121.813,26.493h-2.792a.162.162,0,0,1,0-.324h2.792a.162.162,0,0,1,0,.324",
    transform: "translate(-21.317 -4.693)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23466",
    "data-name": "Path 23466",
    d: "M121.312,27.411a.161.161,0,0,1-.136-.075l-1.508-2.35a.162.162,0,0,1,.272-.175l1.508,2.35a.161.161,0,0,1-.049.223.152.152,0,0,1-.087.026",
    transform: "translate(-21.457 -4.437)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23467",
    "data-name": "Path 23467",
    d: "M119.8,27.411a.152.152,0,0,1-.087-.026.161.161,0,0,1-.049-.223l1.508-2.35a.162.162,0,0,1,.272.175l-1.508,2.35a.161.161,0,0,1-.136.075",
    transform: "translate(-21.457 -4.437)",
    fill: "#ff3d00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentpostsuccess);
export default __webpack_public_path__ + "static/media/commentpostsuccess.95841780320c5f2540b361686b21c4d0.svg";
export { ForwardRef as ReactComponent };